'use client';

import React from 'react';
import { Box, Typography, Button, Paper, Grid, Divider } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AddNewContact from './AddNewContact';

const ManageVendor = ({ vendor, onBack }) => {
  return (
    <Box sx={{ px: 2, py: 2, height: '90vh' }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
        <Button variant="contained" onClick={onBack} startIcon={<ArrowBackIcon />}>
          Back
        </Button>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Paper
        variant="outlined"
        sx={{
          p: 3,
          mb: 3,
          backgroundColor: '#F9F9F9',
          borderLeft: '4px solid #1976D2',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              NetSuite Vendor ID:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.nsVendorId || '—'}
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              Pirate Vendor ID:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.vendorId || '—'}
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              Company Name:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.companyName || '—'}
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              TRIR:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.trir || '—'}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              Vendor Type:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.vendorType || '—'}
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              Products & Services:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.productsServices || '—'}
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              ERM:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.erm3yr || '—'}
            </Typography>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              TRIR 3 YR:{' '}
            </Typography>
            <Typography variant="subtitle1" fontWeight="medium" sx={{ mb: 1 }}>
              {vendor.trir3yr || '—'}
            </Typography>
          </Grid>
        </Grid>
      </Paper>

      <Box sx={{ mt: 2, height: '35vh' }}>
        <AddNewContact vendor={vendor} />
      </Box>
    </Box>
  );
};

export default ManageVendor;
